import { SVGProps } from 'react';
export const LawyerBilby = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		id="Layer_2"
		data-name="Layer 2"
		viewBox="0 0 747.83 1084.08"
		{...props}
	>
		<defs>
			<style>
				{
					'.cls-4{fill:#9dabb9}.cls-8{fill:#9caab9}.cls-14{fill:#0a173c}.cls-20{fill:#223e61}.cls-24{fill:#f89057}.cls-26{fill:#f9f9f9}.cls-31{fill:#f8f8f8}.cls-34{fill:#000222}.cls-36{fill:#9daab9}.cls-41{fill:#203c60}'
				}
			</style>
		</defs>
		<g id="Layer_1-2" data-name="Layer 1">
			<path
				d="M736.67 688.98c-14.41-23.72-35.8-32.32-32.79-65.11.59-6.42 8.3-21.59-4.72-14.7-14.14 7.49-41.43 42.61-48.47 57.46-18.62 39.23-11.79 93.55 34.23 108.16-.43 36.12-15.21 69.81-42.59 93.26-35.93 30.78-87.36 36.59-129.85 15.89-2.83-1.38-17.56-9.74-18.4-11.59-.68-1.49-2.74-17.51-2.21-18.26 16.01 6.28 35.92 2.24 49-8.48 8.49-6.95 18.87-20.36 11.44-31.43-1.56-2.32-5.34-4.01-5.95-5.04-1.68-2.84.05-10.59-6.48-13.48 5.52-4.86 11.84-8.77 17.46-13.51 50.68-42.75 80.2-81.94 22.05-135.85-32.08-29.74-72.57-52.13-108.41-77 1.95-11.68 3.63-23.56 4.88-35.35 4.18-39.37 9.29-82.42 8.07-121.92-.06-1.78-1.87-7.94 1.18-3.15 6.1 9.58 10.89 21.48 23.62 23.82 1.71 16.93 3.08 37.6 10.28 53.17 1.14 2.47 6.45 9.51 6.51 10.11.16 1.47-2.7 7.17-3.19 9.47-8 37.35 29.97 62.98 64.02 59.95 5.96-.53 26.46-5.57 27.54-12.46.35-2.21-.55-1.19-1.45-1.6-5.29-2.37-9.93-2.84-12.06-8.92-3.16-9.02-.13-18.97-.46-28.5-.68-19.48-8.91-40.64-31.05-41.4l-3.9-51.27c4.22-3.36 9.53-4.39 14.23-7.84 21.53-15.79 15.11-49.73-6.33-62.3 17.13-19.89 10.16-57.18-17-63.4 5.17-15.34 3.9-29.72-5.18-43.26-2.36-3.51-14.41-15.31-14.68-16.38-.46-1.77 9.41-18.96 11.04-22.59 25.57-56.72 27.56-115.73 1.68-172.84-5.61-12.39-16.5-33.73-32.34-32.6-12.23.87-33.58 21.78-42.03 30.95-36.04 39.08-55.03 90.54-54.49 143.85-10.75-2.43-22.71-3.48-33.27.23-2.28.8-7.83 4.43-9.23 4.42-1.55-.01-5.22-3.44-7.28-4.36-9.92-4.41-22.43-4.53-32.76-1.33-3.37 1.04-10.19 5.6-12.11 5.78-2.02.19-7.62-2.42-10.85-2.73-8.45-.8-18.83 1.55-26.18 5.79-7.16 4.13-10 10.46-20.3 8.17-4.4-46.14-23.63-90.4-54.5-124.87-11.48-12.82-45.86-46.11-63.03-46.02-16.98.09-25.85 31.63-28.19 44.83-11.25 63.26 3.74 140.78 49.19 188.02 2.52 2.62 14.59 12.07 15.03 12.96 1.1 2.26.6 8.78 2.02 12.97 5.04 14.9 23.77 23.36 38.47 19.49 1.11-.29 1.54-1.15.98.99-3.81 14.64-10.06 28.84-12.9 43.81-28.38 13.73-40.72 43.36-32.79 73.8 2.3 8.82 9.17 13.62-2.07 17.49-10.94 3.77-39.85 2.43-49.62-3.83-2.06-1.32-4.08-5.86-6.12-7.87-6.45-6.35-21.3-12.74-30.27-13.72-49.64-5.45-57.84 56.13-7.65 69.57 5.94 1.59 15.76 1.71 20.38 3.62 4.17 1.73 14.93 10.5 20.38 13.61 32.16 18.36 64.2 27.39 96.34 42.61 6.78 3.21 12.12 6.62 13.24 14.74.46 3.37.66 19.26-1.16 21.14-1.22 1.26-12.8 7.04-15.66 8.82-2.37 1.47-11.95 9.17-12.72 9.31-.71.12-6.42-3.68-8.39-4.37-3.26-1.14-5.62-1.29-8.97-1.53-53.01-.39-106.01-.39-159 0-14-.22-22.66 13.74-27.02 25.45-2.54 6.84-8.39 22.73 2.58 24.44 6.04.94 39.78-1.19 41.34.16l11.13 40.36c-.26 2.18-9.83 6.65-12.57 9.45-19.54 19.99-12.24 72.88 19.6 77.56-.33 7.16-.78 14.57-2.36 21.57-1.69 7.49-10.95 23.57-6.2 29.76.75.98 4.09 3 5 3h116.5c-.06 13.34-.84 26.61-1 39.96v41.95c.99 41.39 5.22 84.01 20 122.86-29.9-4.64-63.99-3-88.01 17.48-6.33 5.39-23.32 25.44-12.35 32.34 7.29 4.58 30.66 4.65 39.85 5.14 36.58 1.96 82.67.94 118.69-6.32 3.28-.66 11.89-1.69 13.31-4.67 1.82-3.8-3.1-26.14-3.49-32.48-3.02-49.12 10.13-96.47 68.53-93.43 57.3 2.99 87.57 52.84 102.72 102.17 1.82 5.91 4.81 25.77 9.33 28.64 2.92 1.86 21.18 4.15 26.07 4.92 14.98 2.37 33.59 5.28 48.33 6.16 20.04 1.2 55.56 2.03 75 0 3.27-.34 18.6-3.86 21.27-5.22 10.14-5.17-.9-19.02-5.76-24.76-25.32-29.89-69.15-34.15-105.51-26.96.45-35.13-3.83-70.01-7-104.88 53.52 26.26 114.08 20.5 160.47-17.01 39.48-31.92 58.64-79.51 55.69-130.17 4.1-3.38 9.15-5.33 13.32-8.67 24.94-20.04 23.91-50.55 8.33-76.2Zm-543.3-265.43c-9.22-18.17-7.64-41.71 5.08-57.83 1.29-1.64 13.03-13.51 14.41-12.06-6.01 23.12-7.12 49.05-19.5 69.9Zm290.48 339.64c-.12.1-2.1.37-1.99-.5l-5.99-84.4c.46-.52 8.71 4.81 9.91 5.57 8.02 5.06 24.08 15.29 29.09 22.88 3.22 4.88 1.83 7.73-.57 12.43-5.6 10.99-21.05 30.48-29.1 40.89-.75.97-1.22 3-1.35 3.11Z"
				style={{
					fill: '#213d60',
				}}
			/>
			<path
				d="M189.87 586.39h-159c51.92 2.7 107.51-3.6 159 0Z"
				style={{
					fill: '#000122',
				}}
			/>
			<path d="M177.87 900.05c-.33-13.91-.16-28.03 0-41.95v41.95Z" className="cls-34" />
			<path
				d="M206.87 819.14c20.23-.48 26.93 2.5 30.86-19.62 2.21-12.47 3.64-27.65 4.14-40.31-.67-11.19-.7-22.78 0-33.96-.84-24.76-4.34-48.71-9-72.92l-5.21-20.06a608.42 608.42 0 0 1 13.04-46.14c3.74-15.27 6.7-30.82.17-45.68-1.48-2.32-2.84-3.41-5-4.99a4210.064 4210.064 0 0 1-74-30.97c-10.93-5.11-35.16-16.59-43.49-23.99-.71-.63-1.72-1.04-1.03-1.99.95-1.3 7.28-3.87 8.52-4.99l3.76-.66c73.58 13.22 146.32 9.06 218.31-10.95l10.93-.37c8.48-1.84 17.55-4.28 26-5.99 14.38-7.12 35.29-2.86 45.75 9.26 15.5 17.97 9.93 44.82 3.09 65.46-30.84 78.41-24.26 164.37-17.81 246.57 1.14 31.07 1.4 65.89-12.52 94.34-38.62 78.98-170.62 61.27-194.26-21.56-2.59-9.07-5.79-22.03-2.24-30.48Z"
				className="cls-26"
			/>
			<path
				d="M603.75 698.91c-1.67-29.87-47.88-62.16-70.57-78.37-22.87-16.34-46.95-30.94-70.15-46.8.63-14.25 3.34-28.55 4.82-42.8 3.57-34.48 7.73-70.16 8.06-104.83.16-16.52-1.79-32.96-1.06-49.49l-58.55 17.92c-.1 24.82-8.48 48.84-31.44 60.99 24.42-4.95 47.46 2.22 52.73 28.74 4.91 24.74-9.66 53.29-16.23 77.14-12.37 44.95-13.94 91.87-12.54 138.39 1.52 50.79 15.39 124.54-7.25 170.48-29.71 60.29-115.34 63.07-162.73 22.28-22.2-19.11-31.52-44.37-31.99-73.43-6.32.15-12.69-.1-19.01 0l-2.04 31.43c-.23 49.05-.5 99.11 12.12 146.8 1.78 6.71 5.17 19.72 8.71 25.27 2.79 4.37 17.35 9.71 22.89 13.1 2.58 1.58 5.01 3.22 7.33 5.17-.2 1.12-1.53 1.79-4 2l.37 2.51c7.98 4.7 15.21 10.33 21.67 16.87l2.96.6c1.69 0 2.91-.53 2.94-2.4.1-5.68-2.59-15.61-2.93-22.08-2.96-56.53 10.91-109.51 78.54-105.42 47.89 2.89 78.31 36.76 97.31 77.6 7.95 17.09 12.53 35.38 18.14 53.3l1.38.71 26.89-18.07.73-2.62c-2.72-.12-7.44 2.43-4.51-2.01 2.56-3.89 20.93-11.3 21.38-12.61-.15-60.01-8.41-119.84-14.87-179.43-25.11-18.26-23.09-51.09-7.92-75.17l-7.09-98.85c-.99-4.34-18.79-13.1-17.97-16.99.54-2.55 5.08-1.25 6.72-.73 13.95 4.38 53.27 29.19 62.25 40.7 7.45 9.54 7.54 15.25 1.83 25.75-16.51 30.32-68.88 74.48-40.78 111.05 13.17 17.14 40.63 16.86 56.45 3.5 3.84-3.24 15.45-16.85 8.86-21.03-9.78-6.21-24.05 13.72-25.32 12.06 2.59-12.05 7.05-23.46 7.48-35.97 27.14-19.24 78.46-58.26 76.39-95.25Z"
				className="cls-36"
			/>
			<path
				d="M413.87 386.62c-1.72-14.74-12.58-29.68-25.09-37.38-36.11-22.24-72.32 1.9-79.87 39.96-8.76-1.89-18.44-2.98-27.03.42-3.13-27.98-26.92-50.99-56.01-47.96 9.94-11.58 24.82-17.8 40.05-14.52 3.3.71 6.11 3.45 9.95 2.54.56-5.81-2.98-11.62-7.67-14.81-12.06-8.22-26.86-.1-36.37 8.28-.44.38-4.92 7.13-3.94 3.06 5.38-14.21 8.48-29.16 15.99-42.47 14.81 13.12 32.36 17.89 46.96 1.47 2.42-2.72 2.21-6.5 6.49-5.49 2.63.62 2.6 2.82 4.6 4.45 12.17 9.91 25.25 13.74 39.63 4.75 4.11-2.57 9.11-11.02 12.66-10.24 1.04.23 5.94 10.81 15.63 13.56 15.41 4.37 18.61-1.04 31.04-4.99 9.22-2.94 19.26-4.03 27.97-8.51l5.02 20.97c1.39 1.46 2.87-7.36 2.97-8.51 2.33-26.04-5.17-58.3-6.97-84.9-4.73-69.97 9.2-131.11 61.46-180.32 7.82-7.36 25.46-24.49 35.51-14.44 12.93 12.93 25.6 50.11 28.72 68.2 8.55 49.5.23 91.33-23.19 135.08-19.6 36.62-58.44 80.34-59.51 123.35-.14 5.62 2.66 27.32.53 30.5l-59.54 17.94Z"
				className="cls-4"
			/>
			<path
				d="M228.87 671.3c6.38 41.71 9.58 86.28 1 126.86-.62 3.15-2 10.12-5.02 11.47l-152.98.52c-1.91 1.27-5.78 1.14-8 0l.12-3.15c5.36-14.13 9.37-29.01 8.88-43.8 13.61-.53 30.69-13.53 28.92-28.37-.79-6.64-5.99-8.57-5.98-9.14.02-1.3 1.73-3.08 2.01-4.99 1.07-7.44-1.67-14.56-8.95-17.45 4.02-4.48 3.87-10.84 1.74-16.2-4.74-11.91-22.78-9.61-24.28-11.71l-9.45-39c34.75-.77 69.58-.92 104.49-.46 4.39-.45 6.56-3.3 6.51-8.53 2.19-10.13 3.65-19.38 11.99-26.48 13.66-11.62 21.62-4.98 29.18 7.83 11.27 19.08 15.42 41.19 19.83 62.6Z"
				className="cls-26"
			/>
			<path
				d="M328.87 216.8c-21.62 2.38-39.1 21.83-36.01 43.95-5.88-7.9-20.74-13.6-27.99-4.49 13.7-.34 24.65 4.76 20.53 20.5-4.75 18.11-40.15 11.32-37.42-15.41s28.32-34.71 51.88-36.57c.01-1.37-2.95-2.08-4.04-2.44-24.95-8.23-56.65 13.03-55.97 40.41l-5.28-5.19c-7.89-4.05-17.68-4.18-24.7 1.71 4.29 1.09 8.66.02 13.05.94 13.74 2.89 18.39 27.6 1.19 30.26-21.81 3.37-34.12-14.81-27.02-34.98s26.56-29.49 46.77-25.7c-.24-5.52-7.5-2.81-5.46-7.94 4.97-12.51 19.94-22.4 33.46-22.02.72.67-7.56 15.64-4.5 18.97 8.93-6.23 12.2-17.59 20.49-24.48 2.65-2.2 11.43-7.48 14.51-7.48h15.5c-1.26 3.54-4.05 6.16-5.86 9.63-2.56 4.93-4.97 12.26-5.18 17.81-.03.93-.7 4.4 1.52 3.51 1.56-.62 7.77-14.45 9.69-17.3 11.87-17.62 33.48-26.48 52.81-15.09.35 1.58-17.1 23.73-9.49 29.38 9.78-18.66 22.6-35.39 45.99-33.92 15.85.99 11.59 3.16 12.52 15.45.79 10.48 2.32 21.02 2.98 31.48-.23.37-1.58-.98-1.99-1-12.91-4.69-25.47-6.29-39-4.99-12.62 2.46-30 15.57-30 29.47v15.98c0 .34 1.73 2.72.99 3.49-1.78 1.86-2.05-2.05-2.99-2.99-1.61-10.11-8.18-16.83-18.86-16.84-1.97 0-9.34.55-6.7 3.35 3.8.1 8.56.52 11.56 2.5.07.47 4.21 3.16 5.23 6.27 7.09 21.63-20.86 29.79-33.64 13.62-11.67-14.77-7.88-37.28 8.41-46.86 11.82-9.18 28.54-7.09 42.66-5.24.61-.19.69-.99.69-1.66-.01-3.34-26.18-6.68-30.35-6.08Z"
				className="cls-31"
			/>
			<path
				d="M196.87 238.77c-3.73 4.84-6.51 10.19-8.51 15.99-3.3-.03-13.88-12.44-16.46-15.52-37.28-44.51-48.9-104.76-43.02-161.79 1.28-12.43 7.6-45.36 21.05-49.98 3.46-1.19 20.13 10.32 23.86 13.09 35.91 26.8 67.37 72.68 78.8 116.07 1.25 4.76 7.38 32.99 5.84 35.22-6.83 2.68-13.78 5.64-18.96 11.04-1.47 1.53-1.77 4.29-3.59 4.9-4.29-40.58-19.17-81.06-40.99-115.39-3.98-6.26-23.56-34.29-28.97-35.99-1.99-.63-4.02-.51-6.06-.44-.17.11 1.07 1.9 1.01 1.99-19.49 56.87-8.02 130.68 34.28 176.24l1.72 4.56Z"
				className="cls-8"
			/>
			<path
				d="m160.87 57.97 14.39 18.09c20.26 28.14 36.54 59.31 46.11 92.79 5.05 17.65 7.35 36.09 13.49 53.45-2.26 1.14-4.72-.56-7.33-.44-11.72.56-23.65 7.83-30.66 16.91-37.61-36.44-50.91-94.31-45.99-145.33.85-8.87 3.42-26 7.19-33.8.91-1.88 2.7-1.54 2.8-1.67Z"
				style={{
					fill: '#f99057',
				}}
			/>
			<path
				d="M657.87 670.3c7-14.86 22.45-32.59 33.97-44.48 1.13-1.17 2.16-2.78 4.02-2.47-.4 10 .81 20.36 4.83 29.64 7.11 16.44 24.11 29.3 32.36 45.59 12.75 25.16 7.75 50.69-16.7 65.6-3.02.35-.45-1.28-.48-1.99 1.64-5.08 7.7-35.51 2.37-37.21-.88-.28-1.74-.25-1.99.57.69 5.46 1.21 11.47-.38 16.66-4.97 18.93-11.17 30.74-32.97 23.45-14.26-4.77-24.8-18.41-29.8-32.16-2.04-5.61-2.55-11.58-4.23-17.26-2.22-15.08 1.87-32.47 9-45.95Z"
				className="cls-26"
			/>
			<path
				d="M307.7 397.77c-7.84-4.1-16.4-3.45-24.69-1.03.63 50.47-53.56 86.29-90.78 41.98-17.7 8.88-37.62 6.89-56.35 2.84 1.19 10.09-2.25 24.97-10.01 31.96 44.6 8.34 92.11 11.98 137.37 6.86 32.52-3.67 64.19-12.03 95.63-18.85-31.99-3.65-53-32.29-51.17-63.76Z"
				className="cls-4"
			/>
			<path
				d="M501.87 306.7c.73.64 16.45-2.91 19.01-3.48 8.59-1.9 19.62-6.26 27.74-7.24 23.91-2.9 33.64 32.85 18.77 48.7-8.15 8.68-30.5 9.21-41.51 13.97 1.84-4.55 4.06-9.41 4.06-14.48 0-12.23-10.04-27.71-23.57-26.52-12.14 1.07-13.92 22.46-5.51 29.01-.93-9.06.42-29.78 14.03-19.5 8.83 6.68 9.26 24.27 2 32-6.23 6.65-22.88.47-28.02-6.01-13.03-16.44-3.69-37.42 3.82-54.12 10.27-22.85 25.49-43.13 38.67-64.25 14.16 9.42 28.69 36.76 15.97 51.9-4.97 5.91-33.47 9.12-43.18 16.8-1.2.95-2.72 1.14-2.27 3.22Z"
				className="cls-31"
			/>
			<path
				d="M706.86 775.19c1.56 33-5.51 63.93-24.18 91.21-41.34 60.4-119.48 81.09-184.33 44.65l-2.47-26.99c71.81 45.99 169.56 9.96 191.91-72.5 3.04-11.23 5.33-23.96 4.08-35.37l14.99-1Z"
				className="cls-36"
			/>
			<path
				d="m174.87 593.39-6.41 8.08c-5.14 8.09-8.51 17.14-7.59 26.88h-153c1.31-10.12 7.82-29.02 18-32.96 3.25-1.68 7.05-2.55 11.39-2.61 45.42-.74 92.26-.81 137.61.61ZM480.87 1043.89c41.54-20.38 110.09-21.45 132 26.96-2.66-.4-6.76 2.15-9.05.56-1-.69-1.24-3.53-2.12-4.88-8.62-13.22-21.54-26.72-38.83-24.63 6.14 4.74 12.96 7.23 19.01 12.46 3.33 2.88 13.83 14.32 14.97 18.01.6 1.93-.41 1.29-1.49 1.46-6.81 1.04-13.75.78-20.55 1.6-5.99-15.68-20.42-29.78-37.94-30.54-.46 2.08 1.1 2.27 2.28 3.21 11.01 8.78 18.87 13.41 27.22 25.76.89 1.32 1.98.73.5 1.99-29.35 1.64-59.06-1.2-88-5.99-8.39-1.31-16.71-4.04-25.34-4.2l-1.66-1.79c4.74-2.38 8.25-6.63 12.69-9.8 4.75-3.4 11.14-7.64 16.31-10.17Z"
				className="cls-26"
			/>
			<path
				d="M533.87 422.56c5.5-10.94 4.07-28.6-6.49-35.96-12.42-8.66-23.16 2.19-21.44 15.43.16 1.2 1.41 5.23 2.93 5.55-3.23-21.68 20.38-24.37 21.08-2.5.25 7.68-1.03 17.68-9.8 19.26-30.23 5.43-33.72-42.48-15.19-52.14 2.65-1.38 6.2-1.07 8.92-2.08s5.2-2.93 8.2-3.79c13.56-3.9 28.01-5 41.42-9.63 17.88 3.88 26.63 26.73 18.56 42.58-6.8 13.36-34.6 19.29-48.18 23.28Z"
				className="cls-31"
			/>
			<path
				d="M232.87 1042.89c4.67 2.51 14.23 9.48 18.47 13.02 2.33 1.95 4.75 4.49 6.53 6.96l-34 4.99c-25.67 3.44-53.8 4.07-80.7 3.14l-1.3-1.14c4.19-8.27 12.69-15.79 18.99-22.49l10.01-7.47c-10.81-1.88-22.16 8.11-28.41 16.06-2 2.54-7.47 13.74-8.25 13.94-1.39.34-14.47-.73-16.85-1.03-1.01-.13-2.16.25-1.47-1.49.79-1.99 7.61-10.44 9.47-12.52 5.05-5.63 10.97-9.04 16.04-13.94 1.17-1.13 2.78-2.16 2.47-4.02-13.83 1.94-22.95 12.14-30.81 22.66-2.22 2.98-4.22 10.15-9.23 6.85-3.03-2 4.32-11.88 6.07-14.01 8.92-10.87 27.29-20.05 40.98-22.5 16.05-4.56 33.96-1.95 50.18 1.75 10.58 2.41 23.02 5.79 31.82 11.23Z"
				className="cls-26"
			/>
			<path
				d="M358.67 348.94c30.12-2.15 50.84 28.3 49.06 56.03-2.71 42.3-52.27 66.29-80.85 30.07-22.69-28.76-7.53-83.3 31.78-86.1Z"
				className="cls-8"
			/>
			<path
				d="M590.87 534.45c-6.17-5.76-7.75-15.26-14.99-19.98.37 14.46 8.46 27.18 18.98 36.47.96 2.3-3.32 1.54-4.47 1.47-14.83-1.01-29.16-9.32-39.03-19.95-2.06-2.22-10.32-14.5-12.97-13.99-1.94.37-1.09 1.37-.54 2.5 8.29 17.16 22 30.89 41.02 35.47.23 1.78-2.25.97-3.36.86-20.96-2.01-46.22-16.84-46.52-40.44-.03-2.07 3.23-16.74 4.02-17.24 1.01-.64 7.98-.59 12.2-3.29 2.57-1.64 4.47-5.02 6.73-6.26 3.03-1.66 7.15-1.74 10.44-4.56 5.3-4.55 1.23-8.92 12.17-4.19 6.79 2.93 16.31 14.2 16.31 21.66v31.47Z"
				className="cls-26"
			/>
			<path
				d="M80.61 417.82c20.47-3.45 48.78 9.28 46.26 33.24-3.97 37.8-75.25 19.47-65.53-17.52 1.79-6.82 12.46-14.57 19.27-15.72Z"
				className="cls-24"
			/>
			<path
				d="M394.87 255.76c23.12 24.91-23.81 43.48-33.47 14.95-12.98-38.33 35.78-53.24 62.51-36.27l3.53 34.36c-.58.84-13.85 5.8-15.89 6.3s-2.51-.38-2.68-.37c1.18-13.78-4.46-26.13-20.56-25.51-2.61.1-9.46.96-7.09 4.31 5.74-1.36 10.29-.62 13.65 2.22Z"
				className="cls-31"
			/>
			<path
				d="M241.87 351.15c-4.15-1.17-14.6-2.65-18.37-1.37-.8.27-1.25.73-1.44 1.56-6.92 22.79-8.04 51.04-18.67 72.25-.97 1.94-5.25 7.27-5.19 8.46.18 3.45 12.59 13.06 15.99 14.68 56.04 26.59 87.2-78.78 27.68-95.58Z"
				className="cls-4"
			/>
			<path
				d="M52.87 716.25c1.23 1.18 23.39-12.75 32.53-7.01 3.33 2.09 5.82 6.83 3.53 10.58-3.3 5.4-27.25 8.63-30.06 18.4 7.73 2.51 33.57-15.8 34.99-1.4 1.18 11.97-16.88 18.87-26.5 18.46-27.62-1.17-35.51-66.48.28-70.74 7.41-.88 21.84 4.49 14.7 12.71-3.96 4.56-28.11 6.57-29.47 19Z"
				className="cls-8"
			/>
			<path
				d="M558.87 423.57c2.97 17.68 3.3 35 1 51.94-2.02.33-5.85 9.64-12.51 2.02-3.66 5.65-4.17 12.43-12.25 13.8-7.26 1.24-11.51-16.27-12.96-21.6-3.3-12.14-4.88-24.73-6.29-37.17 14.8-.69 28.71-6.09 43.01-8.99Z"
				className="cls-31"
			/>
			<path
				d="m232.86 585.4-9.98 33.95c-1.43-7.77-7.06-14.2-10.07-21.4l20.06-12.55Z"
				style={{
					fill: '#9dabba',
				}}
			/>
			<path
				d="M495.87 368.65c.86 1.23-7.34 9.02-7.48 11.99l-4.5 16.96c.72-4.3-.82-8.39-1.05-12.44-.3-5.55-.42-9.71-.89-15.11-.3-3.45.03-6.95-.07-10.4 4.45 3.22 8.34 7.85 13.99 9Z"
				className="cls-26"
			/>
			<path
				d="m228.87 671.3.99-2.99c5.74 43.16 8.95 87.23 1 130.35l-.99-.5c2-10.1 3.53-26.03 4.04-36.42 1.49-30.23-1.63-60.52-5.04-90.44Z"
				style={{
					fill: '#0a183e',
				}}
			/>
			<path
				d="M71.87 810.15c.4.04 2.11 1.65 3.38 1.07 47.37 1.31 95.9-2.01 143.13-.07 1.22.05 3.72-.75 3.48.99l-156.1-.43c-.89-.25-1.36-.88-1.89-1.56 2.62.19 5.41-.26 8 0Z"
				style={{
					fill: '#010d37',
				}}
			/>
			<path
				d="m232.87 652.32-1.04.56c.02-5.96-5.15-15.72-4.89-20.96.48-10.14 10.83-36.12 13.65-48.3 2.35-10.12 4.27-19.06 3.27-29.67l-2.98-13.5c13.82 21.68-7.82 68.31-12.48 91.78 1.76 6.66 3.18 13.32 4.48 20.1Z"
				style={{
					fill: '#081237',
				}}
			/>
			<path
				d="m174.87 593.39-137.54-.04c-3.56.81-8.15.75-11.46 2.04-2.53-.98 1.16-1.53 1.81-1.68 2.32-.55 4.17-1.22 6.66-1.35 42.87-2.33 91.7-.52 135.05.02 1.69.02 4.45-.64 5.49 1.02Z"
				style={{
					fill: '#000325',
				}}
			/>
			<path
				d="M7.87 629.35h152v1h-152z"
				style={{
					fill: '#000e39',
				}}
			/>
			<path
				d="M236.87 1040.9c1.01.85 2.71 1.45 3 2.99l-7-.99c-21.2-11.39-58.48-17.2-82-12.99l-.5-.98c29.86-7.29 54.83 3.93 82.19 11.85 1.57.45 2.54 1.68 4.31.12Z"
				style={{
					fill: '#0e1d42',
				}}
			/>
			<path
				d="M328.87 216.8c8.09-.89 23.52.41 30.34 5.16 1.38.96 3 1.83 2.66 3.83-16.13-2.08-31.22-4.68-46 4-1.35-1.46 1.01-2.03 1.96-2.53 13.6-7.1 26.4-5.31 41.03-3.48-.01-1.38-2.87-2.01-4.03-2.45-2.01-.77-4.03-1.41-6.14-1.85l-19.82-2.67Z"
				style={{
					fill: '#08153c',
				}}
			/>
			<path
				d="m235.87 535.45-57.97-22.51c-4.87-2.05-9.6-4.34-14.35-6.65-.76-.37-4.15-.87-1.68-1.8 21.02 9.83 43.94 16.43 64.67 25.8 3.16 1.43 6.54 3.12 9.33 5.17Z"
				style={{
					fill: '#0e193d',
				}}
			/>
			<path
				d="m223.87 1067.87 3.99.99c-28.94 2.49-57.9 3.64-86.99 3-.56-1.86.85-1.7.99-1.99 11.91 2.21 24.42.4 36.54 1.04l45.46-3.04Z"
				style={{
					fill: '#0a1135',
				}}
			/>
			<path
				d="M478.87 1069.86c29.03 4.54 58.61 5.68 88 5.99-1.45 1.23-1.72.93-3.44 1.05-27.67 1.9-57.58-3.07-85.04-6.08l.48-.96Z"
				style={{
					fill: '#161e40',
				}}
			/>
			<path
				d="M167.87 627.35c.17 5.6-.21 8.28-6.48 9.01l-104.52-.02c.27-1.11 1.47-.98 2.41-1.05 33.14-2.19 68.74 1.69 102.14.1 6.18-.81 5.73-5.89 5.46-11.03 1.67-.27.96 1.89.99 2.99Z"
				style={{
					fill: '#010420',
				}}
			/>
			<path
				d="M715.87 742.22c-.27-7.02.52-14.05-.99-20.98 4.34 1.2 5.55 6.45 5.98 10.5 1.06 9.97-1.43 21.22-4.99 30.45-.01-.2-1.1-.93-.83-2.2 2.25-10.36 7.02-20.99 3.52-31.97-.33-1.05-.25-3.02-1.69-2.79 1.72 6.34.86 12.12-.01 18.47-1.31 1.6-.97-.76-1-1.49Z"
				className="cls-14"
			/>
			<path
				d="M408.87 274.74c-.47.03-1.7 1.42-1.99 1 2.29-7.9 1.45-17.61-6.06-22.42-4.88-3.13-15.62-5.57-19.95-.56 3.84-1.01 10.74-.55 14.09 1.57 1.06.67-.14 1.39-.09 1.44-4.52-2.92-8.37-1.63-13.01-1.43-1.43.06-1.81.73-2.98-1.08 1.77-5.63 9.49-4.91 14.24-4.22 13.56 1.96 17.97 13.4 15.76 25.71Z"
				style={{
					fill: '#0b1538',
				}}
			/>
			<path
				d="M558.87 423.57c.05-.01.65-1.96 1.01-.5.23 17.78 5.15 35.97.93 53.43-.4-.15-.85-1-.94-.99 3.14-17.22-1.35-34.64-1-51.94Z"
				className="cls-14"
			/>
			<path
				d="M349.87 267.74c0 1.07.65 3.27-.99 2.99.61-13.3-8.61-20.18-21.42-18.88-.95.1-3.77.44-3.58 1.9 4.55-.5 8.71.9 13 2.06-.15.41-1.02.86-1 .95-5.18-.79-11.02-3.34-15.99-1-1.98-2.35 7.3-5.39 8.94-5.55 11.07-1.06 21.06 6.12 21.05 17.53Z"
				style={{
					fill: '#071033',
				}}
			/>
			<path
				d="M72.87 763.2c1.38 4.34.42 11.54-.27 16.21-1.57 10.64-5.75 20.49-8.73 30.74-.68-.86-1.05-.43-.85-2.19.48-4.05 4.16-11.18 5.34-15.8 2.52-9.83 4.2-19.76 3.52-29.97.74-.24.89 1.01.99 1Z"
				style={{
					fill: '#081336',
				}}
			/>
			<path
				d="M657.87 670.3c-4.65 9.87-8 22.62-8.99 33.47-.37 4.02.19 8.39-.01 12.48-.06 1.11.69 3.26-.99 2.99-1.32-16.75 1.32-30.54 7.54-45.89.12-.3 1.59-5.67 2.45-3.05Z"
				style={{
					fill: '#060e33',
				}}
			/>
			<path
				d="M420.87 226.79c-12.01-.72-17.49-6.08-33.8-4.28-1.6.18-4.16 1.14-5.2-.72 12.94-2.52 27.38-1.52 39 4.99Z"
				style={{
					fill: '#071031',
				}}
			/>
			<path
				d="M241.87 759.2c-1.66-1.04-1-3.79-1.02-5.48-.09-7.65-.08-15.35 0-23 .02-1.69-.64-4.44 1.02-5.48.37 10.86.43 23.12 0 33.96Z"
				style={{
					fill: '#000525',
				}}
			/>
			<path
				d="M532.87 810.14c1.48-5.5 2.57-8.78 5-1.51l-5 1.51Z"
				style={{
					fill: '#b0bbc5',
				}}
			/>
			<path
				d="M356.87 513.47c-24.71 11.45-51.14 17.25-78.41 10.71-1.45-.35-3.07-1.25-3.59-2.72.13-1 1.12-1.63 2-2 20.05-.62 38.81-1.41 59.07-5.36.12-.02-2.18 1.17-.07-.63 11.78-3.37 23.51-10.25 31-19.97-1.99.5-11.97-1.64-11.98-3.51 4.75-6.27 19.92-5.85 25.93-1.95 11.13 7.23 8.35 22.98-4.45 8.46-6.14 6.21-11.94 12.43-19.5 16.97Z"
				className="cls-41"
			/>
			<path
				d="M356.87 513.47c-19.91 11.93-49.45 16.88-72.22 12.71-2.72-.5-10.26-1.1-9.78-4.72 1.72 1.48 3.76 2.1 5.94 2.56 25.1 5.3 49.3.81 72.04-10.06 1.02-.49 3.41-2.5 4.01-.49Z"
				style={{
					fill: '#0a163b',
				}}
			/>
			<path
				d="m335.87 513.47.64 1.12c-10.45 3.14-21.37 3.34-32.1 4.91l-27.54-.04c19.57-3.1 39.76-.49 59-5.99Z"
				style={{
					fill: '#151f41',
				}}
			/>
			<path
				d="m463.87 297.71-.82-.27c-2.65-31.7-5.39-64.66-5.52-97.88-.22-54.06 7.04-98.58 34.94-145.62 4.42-7.45 10.02-16.66 16.4-21.94 10.16 9.19 22.75 41.69 26.13 55.31 14.02 56.49-1.13 100.56-29.71 148.38-10.38 17.37-26.28 44.09-38.58 59.37-1 1.24-1.35 1.82-2.83 2.64Z"
				className="cls-24"
			/>
			<path
				d="M508.87 32c-5.59 10.28-12.97 19.54-18.81 29.66-32.76 56.8-33.25 122.89-28.21 186.61l2.01 49.44c-.22.12-.09 1.95-1.49 0-2.16-3.02-3.77-14.34-4.38-18.6-9.45-65.03-11.13-151.03 20.35-210.16 3.42-6.42 22.58-37.84 28.2-38.83 1.71-.3 1.74 1.37 2.32 1.89Z"
				style={{
					fill: '#1e3b60',
				}}
			/>
			<path
				d="M353.87 324.68c7.03-24.36 50.64-20.59 57.21 1.28 4.87 16.21-7.74 4.81-13.24 2.24-14.34-6.71-28.81-4.17-43.98-3.52Z"
				className="cls-41"
			/>
			<path
				d="M201.87 666.31c3.67 3.73.76 6.19-3.45 7.04l-97.1-.02c-1.2.38-1.13-.52-1.46-1.03-1.99-2.2-2.29-5.8.88-6.99 32.8-.56 65.52-.71 98.16-.43l2.95 1.43Z"
				style={{
					fill: '#203a5f',
				}}
			/>
			<path
				d="M209.62 708.02c-1.11 1.11-3.65 1.15-5.21 1.28-28.79 2.42-60.91-1.91-90.06-.02-6.93.09-7.86-8.24-1.03-9.05l95.54.54c2.52 1.21 2.53 5.49.76 7.26Z"
				style={{
					fill: '#091d47',
				}}
			/>
			<path
				d="M210.87 750.21c-.28 2.99-1.55 4.76-3.81 5.32-16.61.61-33.79.3-50.19-.33-2.96-.97-2.77-5.56.68-6.42l51.32-.58c.83-.03 1.84 1.19 2 2Z"
				className="cls-20"
			/>
			<path
				d="M201.87 666.31c-1.78-.56-3.56-.95-5.45-1.04-31.55-1.49-64.03.77-95.54.54-.75.52-1.74 1.31-1.92 2.19-.05.21.79 4.11.91 4.3-3.28-1.26-2.44-6.32 0-7.5l98.57-.55c2.38-.34 2.5 1.09 3.44 2.05Z"
				className="cls-34"
			/>
			<path
				d="m208.87 748.22-50.5 1c-3.36.35-2.91 3.76-1.5 5.99.87.28.86.62 0 1-4.24-1.72-4.12-7.07.53-7.96l51.47-.03Z"
				style={{
					fill: '#00021e',
				}}
			/>
			<path
				d="M156.87 756.21v-1c7.76-1.24 47.91 2.01 51.6-.9 1.06-.84 1.23-3.11 2.4-4.09.54 2.67-.56 5.58-3.53 5.97l-50.47.03Z"
				style={{
					fill: '#01041a',
				}}
			/>
			<path
				d="M377.87 432.56c-12.75 4.24-22.22-7.57-24.3-19.06-4.08-22.5 16.17-45.59 34.41-24.04-29.25-49.9-71.82 31.12-26.77 43.95l1.67 2.15c-1 1.66-3.77 1.11-5.38.9-32.39-4.15-27.97-62.39 2.13-69.58 37.42-8.93 48.76 49.04 18.25 65.68Z"
				className="cls-41"
			/>
			<path
				d="M362.87 435.56c-30.63-1.55-28.54-51.24-5.89-61.32 22.9-10.19 38.76 13.69 34.88 34.35l-1.43-9.04c-3.14-14.02-19.05-23.65-29.38-10.26-12.07 15.65-5.67 43.75 16.83 43.28-5.05 2.75-9.1 3.3-15 3Z"
				className="cls-26"
			/>
			<path
				d="M268.87 396.6c.65 10.32-.79 20.81-7.49 28.98-.85 1.04-5.76 5.79-6.51 5.98-25.96 5.28-25.19-43.91-5.56-49.26 9.58-2.61 17.87 5.17 19.56 14.3Z"
				className="cls-41"
			/>
			<path
				d="M268.87 395.6c.03.33-.02.67 0 1-18.04-31.41-39.44 1.61-29.5 24.97 2.14 5.03 9.85 11.46 15.5 9.99l-.66.81c-2.99-.6-7.07 1.1-9.34 1.19-29.25 1.96-27.9-35.87-14.37-52.71 15.49-19.28 40.83-9.49 38.37 14.75Z"
				className="cls-26"
			/>
			<path
				d="M244.87 433.56c-10.25 4.1-20.63-5.12-24.48-14-7.92-18.26 3.07-50.62 25.09-52.82 17.96-1.79 25.49 14.89 25.4 30.35l-2.01-1.49c-3.1-32.77-35.41-28.32-43.71-.21-4.77 16.16-1.23 39 19.71 38.17Z"
				style={{
					fill: '#1f3b5e',
				}}
			/>
			<path
				d="M208.87 707.26h-98v-5c11.11.83 22.39-.82 33.37-.85 5.57-.02 12.45.54 18.09.9 13.32 1.6 32.46-2.31 45.03-.04 3.59.65 2.12 2.44 1.51 4.99Z"
				className="cls-20"
			/>
			<path
				d="M377.59 391.79c8.13-2.37 10.14 10.34 1.6 10.55-6.22.16-7.28-8.89-1.6-10.55Z"
				style={{
					fill: '#f8f9f9',
				}}
			/>
			<path
				d="M257.53 391.82c6.46-.58 7.25 10.15.81 10.8-7.57.76-7.1-10.23-.81-10.8Z"
				style={{
					fill: '#f7f8f9',
				}}
			/>
		</g>
	</svg>
);
